import type {
  GetProductBySlugQuery,
  RentalPlan,
  Variant,
} from "@/api/graphql/generates";
export type Product = NonNullable<GetProductBySlugQuery["product"]>;

export type ProductEventProperties = {
  brand: string;
  available?: boolean;
  category: string;
  currency: string;
  delivery_time?: string;
  discount_amount?: number;
  discount_percentage?: number;
  displayed_price: number;
  grover_care_coverage?: number;
  has_grover_care_deductibles?: boolean;
  name: string;
  non_discounted_price: number;
  order_id?: string;
  price: number;
  image_url: string;
  sku: string;
  product_id: string;
  product_sku: string;
  product_type: string;
  product_name: string;
  product_variant: string;
  store_id: number;
  store: string;
  sub_category: string;
  subscription_length: number;
  variant: string;
  quantity: 1;
  bundleID?: number;
  variant_sku: string;
};

const productCategories = (
  permalink: string,
): { category: string; dimension13: string } | null => {
  if (!permalink) return null;
  const [category = "", dimension13 = ""] = permalink
    .split("/")
    .filter((item) => item);
  return {
    category: category || "",
    dimension13: dimension13 || "",
  };
};

export const formatSegmentProductPayload = (
  product: Product,
  rentalPlan: RentalPlan,
  variant: Partial<Variant>,
  store: string,
  storeId: number,
  order_id?: string,
  groverCareCoverage?: number,
  hasGroverCareDeductibles?: boolean,
): ProductEventProperties => {
  const categories = productCategories(product.category?.permalink ?? "");

  const discountAmount =
    (rentalPlan.price.inCents * (rentalPlan.discount?.percentage || 0)) / 10000;

  return {
    brand: product.brandName,
    available: true,
    currency: product.marketPrice.currency,
    category: categories?.category ?? "",
    discount_amount: discountAmount || 0,
    discount_percentage: Number(rentalPlan.discount?.percentage) || 0,
    displayed_price: Number(rentalPlan.price.inCents / 100),
    grover_care_coverage: groverCareCoverage,
    has_grover_care_deductibles: hasGroverCareDeductibles,
    name: product.name,
    image_url: product.originalImageUrl,
    non_discounted_price:
      Number(product.cheapestRentalPlan?.oldPrice?.inCents) / 100,
    price: Number(product.cheapestRentalPlan?.price?.inCents) / 100,
    product_id: String(variant.id),
    product_name: product.name,
    product_sku: product.sku,
    product_type: "rental",
    product_variant: String(variant.id),
    sku: product.sku,
    store: store,
    store_id: Number(storeId),
    sub_category: categories?.dimension13 ?? "",
    subscription_length: rentalPlan.length.value,
    variant: String(variant.id),
    quantity: 1,
    order_id,
    variant_sku: String(variant.sku),
  };
};
